import { registerApp } from '@okapi/core';
import { preloadedState, router, store } from 'store';
import { createEntry } from '../common';

if (preloadedState.isBot === false) {
  registerApp(__NAME__, () => createEntry({ store, router }));
}
